import { Button } from '@toggle/design-system';
import React from 'react';

import * as S from './ChartEmpty.styles';

export interface ChartEmptyLocales {
  imgAlt: string;
  title: string;
  description: string;
  btnLabel: string;
}

export interface ChartEmptyProps {
  onSearchAgain?: () => void;
  assetName?: string;
  locales: ChartEmptyLocales;
}

export const ChartEmpty = ({
  onSearchAgain,
  assetName = '',
  locales,
}: ChartEmptyProps) => {
  return (
    <S.ChartEmptyRoot data-testid="chart-empty">
      <S.EmptyImage alt={locales.imgAlt} />
      <S.Title data-testid="title">
        {locales.title.replace('{{asset}}', assetName)}
      </S.Title>
      <S.Description>{locales.description}</S.Description>
      <Button
        data-testid="chart-empty-button"
        label={locales.btnLabel}
        onClick={onSearchAgain}
      />
    </S.ChartEmptyRoot>
  );
};
